import React from "react";
import ReactDOM from "react-dom";
import Router from "./Router";
import registerServiceWorker from "./registerServiceWorker";
import { is_wechat, getQueryVariable, autologin } from "../src/tools/wechatBrower";
import { debug } from "./request";
import { Toast } from "antd-mobile";

import "./index.css";

Toast.config({ duration: 3 })


ReactDOM.render(<Router />, document.getElementById("root"), () => {
  if (!debug) {
    // 判断是否是微信浏览器
    let _is_wechat = is_wechat();
    console.log("index.js 初始化")
    let token = localStorage.getItem("openid")
    if (_is_wechat) {
      const code = getQueryVariable('code');

      if (token) {
        console.log("有token 不跳转");
      } else if (code) {
        Toast.loading('登录中...', 0);  // 设置 duration 为 0，手动关闭
        autologin()
          .then(() => {
            Toast.hide();
            Toast.success('登录成功');
            // 清除URL中的code参数
            window.history.replaceState({}, document.title, window.location.pathname);
          })
          .catch(error => {
            Toast.hide();
            Toast.fail('登录失败，请重试');
            console.error('登录失败:', error);
            // 可以在这里添加重试逻辑
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          });

        
      } else {
        Toast.loading('静默登录...', 1.5);
        let base_url = window.location.protocol + "//" + window.location.host + window.location.pathname;
        let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxdc8058c0b71a3b35&redirect_uri=${encodeURIComponent(
          base_url
        )}&response_type=code&scope=snsapi_userinfo&state=1&connect_redirect=1#wechat_redirect`;
        console.log("没有token 跳转授权URI");

        // 给用户一个视觉反馈的时间，然后再跳转
        setTimeout(() => {
          window.location.href = url;
        }, 1500);
      }
    } else {
      window.location.href = "#/Warn";
    }
  } else {
    let openid = "o3KXx5lSukpaX5Lwn_JRTiW5R_hk";
    localStorage.setItem("openid", openid);
  }
});
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js